import { render, staticRenderFns } from "./iFrameVideo.vue?vue&type=template&id=03e46066&scoped=true&lang=pug&"
import script from "./iFrameVideo.vue?vue&type=script&lang=js&"
export * from "./iFrameVideo.vue?vue&type=script&lang=js&"
import style0 from "./iFrameVideo.vue?vue&type=style&index=0&id=03e46066&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e46066",
  null
  
)

export default component.exports